import React from 'react';
import { Button } from '@chakra-ui/react';

enum Action {
  Prev = 'prev',
  Next = 'next',
}

interface PageButtonProps {
  pageNumber?: number;
  currentPage: number;
  action?: Action;
  icon?: any;
  onClick: (page: number) => void;
}

export const PaginationPageButton: React.FC<PageButtonProps> = React.memo(
  ({ pageNumber, currentPage, onClick }) => {
    return (
      <Button
        aria-label={`${pageNumber}`}
        onClick={() => {
          if (pageNumber) {
            onClick(pageNumber);
          }
        }}
        size="xs"
        variant={pageNumber === currentPage ? 'solid' : 'secondary'}
      >
        {pageNumber}
      </Button>
    );
  },
);

PaginationPageButton.displayName = 'PaginationPageButton';
